// extracted by mini-css-extract-plugin
module.exports =  {"list-collapse":"_1c9529d521--list-collapse--OORI9","list-item":"_1c9529d521--list-item--RK3NV"};